import type { Namespace, TFunction } from 'i18next'
import type { z } from 'zod'

import type {
  ErrorMapContext,
  ErrorMapWithContext,
  ValidationRuleFactory,
} from './types.ts'

export function createErrorMap<TNamespace extends Namespace>(
  t: TFunction<TNamespace>,
  factory: ValidationRuleFactory<TNamespace>,
  context?: ErrorMapContext
): ErrorMapWithContext {
  const rules = factory(t, context)

  return (issue: z.ZodIssue, overrideContext?: ErrorMapContext) => {
    const resolvedContext = overrideContext ?? context ?? {}
    for (const rule of rules) {
      const result = rule(issue, resolvedContext)

      if (result?.message) {
        return result
      }
    }

    return { message: resolvedContext.defaultError ?? issue.message }
  }
}
